import React from 'react';
import './aiCompose.css';

/**
 * Toolbar control for optional AI Email Composer.
 * Uses SVG (not emoji) so it stays visible across Windows fonts/themes.
 */
export default function AIComposeButton({ active = false, disabled = false, onClick }) {
  return (
    <button
      type="button"
      className={`toolbar-icon-btn compose-ai-btn${active ? ' active' : ''}`}
      title="Generate email with AI"
      aria-label="Generate email with AI"
      aria-pressed={active}
      disabled={disabled}
      onClick={onClick}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2l1.35 4.15L17.5 7.5l-4.15 1.35L12 13l-1.35-4.15L6.5 7.5l4.15-1.35L12 2z" />
        <path d="M19 12l.9 2.76L22.7 15.7l-2.8.9L19 19.4l-.9-2.8-2.8-.9 2.8-.94L19 12z" opacity="0.85" />
        <path d="M6.2 14.2l.7 2.1 2.1.7-2.1.7-.7 2.1-.7-2.1-2.1-.7 2.1-.7.7-2.1z" opacity="0.75" />
      </svg>
    </button>
  );
}
